export default __webpack_public_path__ + "static/media/xpensityv2-lg-1.afe9bee2.webp";